import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../public/logo.png'


const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-image"
}, null, -1)
const _hoisted_3 = { class: "login-box-msg" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-7" }
const _hoisted_6 = { class: "col-5" }

import AppCheckbox from '@/components/checkbox/checkbox.vue';
import AppInput from '@/components/input/input.vue';
import AppButton from '@/components/button/button.vue';
import {useField, useForm} from 'vee-validate';
import {onMounted, onUnmounted, ref} from 'vue';
import * as yup from 'yup';
import {LoginRequest} from '@/interfaces/loginRequest';
import authenticationClient from '@/services/authenticationClient';
import {useToast} from 'vue-toastification';
import store from '@/store/store';
import {useI18n} from 'vue-i18n';
import {getPropertyName} from '@fluffy-spoon/name-of';
import Card from '@/components/card/card.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();
const {t} = useI18n();
const appElement = document.getElementById('app') as HTMLElement;

onMounted(() => {
  appElement.classList.add('login-page');
});
onUnmounted(() => {
  appElement.classList.remove('login-page');
});

// const loginRequest = ref<LoginRequest>({});
//
const {errors: errors, handleSubmit} = useForm<LoginRequest>({
  initialValues: {},
  validationSchema: yup.object({
    username: yup.string().required().email(),
    password: yup.string().required()
  })
});

const onSubmit = handleSubmit(async (values) => {
  try {
    isAuthLoading.value = true;
    const loginRequest = values as LoginRequest;
    //const token = await loginByAuth(this.username, this.password);
    const tokens = await authenticationClient.login(loginRequest);
    await store.dispatch('auth/login', tokens.accessToken);
    await store.dispatch('auth/refresh-token', tokens.refreshToken);
    toast.success(t('areas.login.loginSucceeded'));
  } catch (error: any) {
    toast.error(error.response);
  }
  isAuthLoading.value = false;
});
const isAuthLoading = ref<boolean>(false);
const {value: rememberMe} = useField('rememberMe');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Card, { class: "card card-outline card-primary" }, {
      header: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "h1",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('labels.signInToStart')), 1),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
        }, [
          _createVNode(AppInput, {
            label: _ctx.$t('areas.login.labels.username'),
            name: _unref(getPropertyName) < LoginRequest > ((u) => u.username),
            autocomplete: "off",
            class: "mb-3",
            icon: "envelope",
            placeholder: "Email",
            type: "email"
          }, null, 8, ["label", "name"]),
          _createVNode(AppInput, {
            label: _ctx.$t('areas.login.labels.password'),
            name: _unref(getPropertyName) < LoginRequest > ((u) => u.password),
            autocomplete: "off",
            class: "mb-3",
            icon: "envelope",
            placeholder: "Password",
            type: "password"
          }, null, 8, ["label", "name"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(AppCheckbox, {
                modelValue: _unref(rememberMe),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(rememberMe) ? (rememberMe).value = $event : null)),
                type: "icheck"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('labels.rememberMe')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AppButton, {
                loading: isAuthLoading.value,
                block: "true",
                class: "btn-primary",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('labels.signIn')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}
}

})